import {merge} from 'rxjs';
import {map, scan} from 'rxjs/operators';
import {wsLogout$} from '@/user/auth-ws';
import {contractSnapshotOrders$, contractIncrementalOrders$} from '@/orders-contract/orders-contract';
import type {ws} from '@/types';

type ContractOrderRaw = ws.ContractOrderRaw;
type ContractClosedRaw = ws.ContractClosedRaw;
type AOPMsg = ws.AOPMsg;

export type Cache = Map<string, ContractOrderRaw>;
type Action = (map: Cache) => Cache;

const reset$ = wsLogout$.pipe(
  map(() => (cache) => {
    cache.clear();
    return cache;
  })
);

const snapshotAction$ = contractSnapshotOrders$.pipe(
  map((msg: AOPMsg): Action => {
    const {closed} = msg.orders;
    return function (cache: Cache) {
      closed.filter(historyOrderFilter).forEach((o: ContractClosedRaw) => cache.set(o.orderID, o));
      return cache;
    };
  })
);
const updateAction$ = contractIncrementalOrders$.pipe(
  map((msg: AOPMsg): Action => {
    const {closed} = msg.orders;
    return function (cache: Cache) {
      closed.filter(historyOrderFilter).forEach((o: ContractClosedRaw) => cache.set(o.orderID, o));
      return cache;
    };
  })
);

export const contractHistoryOrdersCache$ = merge<[Action, Action, Action]>(snapshotAction$, updateAction$, reset$).pipe(
  scan((p: Cache, c: Action): Cache => c(p), new Map<string, ContractOrderRaw>())
);

function historyOrderFilter(raw) {
  return (
    ['New', 'Replace', 'Cancel', 'LiqRequest'].includes(raw.action) &&
    !['ReplaceRejected', 'CancelRejected'].includes(raw.execStatus)
  );
}
